import { makeAction, makeReducer } from '@finn-no/redux-actions';
import { toast } from '@finn-no/common-browserbundle';

import i18n from 'shared/locale/i18n.js';
import { savedSearchNameFromRequest } from '../util/formatting.js';
import { deepEquals } from '../util/deepEquals.js';

import filterActions from './filterActions.js';

const actions = {};

actions.requestReceived = payload => (dispatch, getState) => {
    const savedSearchName = getState().filterState.savedSearchId
        ? getState().filterState.savedSearchName
        : savedSearchNameFromRequest(payload);

    dispatch(
        actions.setData({
            enabled: true,
            name: savedSearchName,
            currentState: { ...getState().filterState },
        })
    );
};

actions.saveSearch = payload => (dispatch, getState) =>
    fetch('save-search', {
        method: 'POST',
        credentials: 'include',
        cache: 'no-cache',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: Object.entries(payload)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join('&'),
    })
        .then(response => (response.status >= 200 && response.status < 300 ? response.json() : Promise.reject()))
        .then(savedSearchId => {
            toast({ message: i18n.t('savedSearch.saveSuccess') });

            const name = payload.savedSearchName ? payload.savedSearchName : getState().savedSearch.name;
            dispatch(filterActions.setFilters({ savedSearchId, savedSearchName: name }));
            dispatch(actions.setData({ searchWasSaved: true, unsavedChanges: false, showModal: false, name }));
        })
        .catch(() => {
            toast({ message: i18n.t('result:savedSearch.saveError'), level: 'error', timeout: 10000 });

            dispatch(actions.toggleModal());
        });

actions.setEnabled = makeAction('SAVED_SEARCH/ENABLE', 'enabled');

actions.setData = makeAction('SAVED_SEARCH/SET_DATA', (state, { payload }) => ({ ...state, ...payload }));

actions.toggleModal = makeAction('SAVED_SEARCH/TOGGLE_MODAL', state => ({ ...state, showModal: !state.showModal }));

actions.filterUpdate = makeAction('SAVED_SEARCH/FILTER_UPDATE', (state, { payload }) => ({
    ...state,
    unsavedChanges: !deepEquals(state.currentState, payload),
    searchWasSaved: false,
}));

export default actions;

export const reducer = makeReducer(actions);
